import { useInfiniteQuery } from '@tanstack/react-query'

import useQuery from '@shared/hooks/src/useQuery'
import { useMe } from '@shared/providers/src/MeProvider'
import API from '@shared/services/src/API'
import { flatten, pageParam, QK } from '@shared/utils'

const LIMIT = 25

export function useSOPsNotifications() {
  const me = useMe()
  const query = { limit: LIMIT }

  return useInfiniteQuery({
    queryKey: QK.users.id(me.id).sopNotifications.list(query),
    queryFn: ({ pageParam }) => API.users.id(me.id).sopNotifications.list({ ...query, offset: pageParam * LIMIT }),
    select: flatten,
    initialPageParam: 0,
    getNextPageParam: pageParam(LIMIT),
  })
}

export function useSOPNotification(sopId) {
  const me = useMe()
  const query = { limit: 1, read: false, sop_id: sopId }

  return useQuery({
    queryKey: QK.users.id(me.id).sopNotifications.list(query),
    queryFn: () => API.users.id(me.id).sopNotifications.list(query),
    select: (data) => data?.[0],
    enabled: Boolean(sopId),
  })
}

export function useSOPNotificationIndicator() {
  const me = useMe()
  const query = { limit: 1, read: false }

  return useQuery({
    queryKey: QK.users.id(me.id).sopNotifications.list(query),
    queryFn: () => API.users.id(me.id).sopNotifications.list(query),
    staleTime: 5 * 60 * 1000,
    select: (data) => data?.filter((n) => !n.readAt).length > 0,
  })
}
